<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, inject, onBeforeUnmount, provide, useId } from "vue";
import { Primitive } from "@maas/vue-primitive";
import {
  MagicAccordionInstanceId,
  MagicAccordionViewActive,
  MagicAccordionViewId
} from "../symbols";
import { useAccordionView } from "../composables/private/useAccordionView";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicAccordionView",
  props: {
    id: { type: String, required: false },
    asChild: { type: Boolean, required: false },
    active: { type: Boolean, required: false }
  },
  setup(__props) {
    const instanceId = inject(MagicAccordionInstanceId, void 0);
    if (!instanceId) {
      throw new Error(
        "MagicAccordionView must be nested inside MagicAccordionProvider"
      );
    }
    const mappedId = computed(() => __props.id ?? `magic-accordion-view-${useId()}`);
    const mappedActive = computed(() => view.active);
    const { initializeView, deleteView } = useAccordionView(instanceId);
    const view = initializeView({
      id: mappedId.value,
      active: __props.active ?? false
    });
    provide(MagicAccordionViewId, mappedId.value);
    provide(MagicAccordionViewActive, mappedActive);
    onBeforeUnmount(() => {
      deleteView(mappedId.value);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Primitive), {
        "as-child": _ctx.asChild,
        "data-active": _unref(view)?.active,
        class: "magic-accordion-view"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {
            viewActive: _unref(view)?.active
          })
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["as-child", "data-active"]);
    };
  }
});
</script>
